import UserTagsMetadataModal from './UserTagsMetadataModal';
import { userTagsCategoryInfos } from '../Service/Utils';
import AuthFetchService from '../Service/AuthFetchService';

import { Button, Row, Col, Input, Space, Table, Popconfirm, message } from 'antd';
import { } from '@ant-design/icons';
import React from 'react';
import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

class UserTagsManagementView extends React.Component {
    static tableDelta = 435

    constructor() {
        super();
        this.state = {
            objectKindKey: 'all',
            timeKindKey: 'all',
            processingKindKey: 'all',
            categoryClass1Key: 'all',
            categoryClass2Key: 'all',
            searchKey: '',
            pageNo: 1,
            pageSize: 20,
            total: 0,
            tags: [],
            tableHeight: document.body.clientHeight - UserTagsManagementView.tableDelta,
            metadataModal: {
                visible: false,
            }
        };
    }

    render() {
        return <>
            <Row style={{ backgroundColor: '#fafafa', margin: '12px 0 0 0',  padding: '10px' }}>
                <Col flex='100%'>
                    <Row>
                        <Col flex='100px' style={{ textAlign: 'right', fontSize: 12}}>
                            <span>对象：</span>
                        </Col>
                        <Col flex='auto'>
                            <SegmentSelect
                                value={this.state.objectKindKey}
                                onChange={objectKindKey => this.refreshSummaries({ objectKindKey })}
                                options={[
                                    {
                                        title: '全部',
                                        key: 'all'
                                    }, {
                                        title: '用户',
                                        key: '用户'
                                    }, {
                                        title: '销售',
                                        key: '销售'
                                    }, {
                                        title: '课程',
                                        key: '课程'
                                    }
                                ]}
                                style={{fontSize: 12}} />
                        </Col>
                    </Row>
                    <Row style={{ margin: '12px 0 0 0'}}>
                        <Col flex='100px' style={{ textAlign: 'right', fontSize: 12 }}>
                            <span>产出时效：</span>
                        </Col>
                        <Col flex='auto'>
                            <SegmentSelect
                                value={this.state.timeKindKey}
                                onChange={timeKindKey => this.refreshSummaries({ timeKindKey })}
                                options={[
                                    {
                                        title: '全部',
                                        key: 'all'
                                    }, {
                                        title: '离线',
                                        key: '离线'
                                    }, {
                                        title: '实时',
                                        key: '实时'
                                    }
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row style={{ margin: '12px 0 0 0' }}>
                        <Col flex='100px' style={{ textAlign: 'right', fontSize: 12 }}>
                            <span>加工类型：</span>
                        </Col>
                        <Col flex='auto'>
                            <SegmentSelect
                                value={this.state.processingKindKey}
                                onChange={processingKindKey => this.refreshSummaries({ processingKindKey })}
                                options={[
                                    {
                                        title: '全部',
                                        key: 'all'
                                    }, {
                                        title: '事实',
                                        key: '事实'
                                    }, {
                                        title: '统计',
                                        key: '统计'
                                    }, {
                                        title: '预测',
                                        key: '预测'
                                    }
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row style={{ margin: '12px 0 0 0' }}>
                        <Col flex='100px' style={{ textAlign: 'right', fontSize: 12 }}>
                            <span>一级类目：</span>
                        </Col>
                        <Col flex='auto'>
                            <SegmentSelect
                                value={this.state.categoryClass1Key}
                                onChange={categoryClass1Key => this.refreshSummaries({ categoryClass1Key })}
                                options={[{ title: '全部', key: 'all' }, ...userTagsCategoryInfos]}
                            />
                        </Col>
                    </Row>
                    <Row style={{ margin: '12px 0 0 0' }}>
                        <Col flex='100px' style={{ textAlign: 'right', fontSize: 12 }}>
                            <span>二级类目：</span>
                        </Col>
                        <Col flex='auto'>
                            <SegmentSelect
                                value={this.state.categoryClass2Key}
                                onChange={categoryClass2Key => this.refreshSummaries({ categoryClass2Key })}
                                options={[{ title: '全部', key: 'all' }, ...this.currentClass2Options()]}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row style={{ margin: '12px 0 0 0' }}>
                <Col>
                    <Input.Search
                        placeholder='输入标签名称/字段名搜索'
                        style={{ width: '300px' }}
                        value={this.state.searchKey}
                        onChange={({ target: { value } }) => this.refreshSummaries({ searchKey: value })}
                    />
                </Col>
                <Col flex='auto'></Col>
                {AuthFetchService.allow('datap:admin') &&  <Col>
                    <Space>
                        <Button
                            type='primary'
                            ghost
                            onClick={() => this.setState(({ metadataModal }) => {
                                metadataModal.visible = true;
                                return { metadataModal };
                            })}
                        >
                            管理基础信息
                        </Button>
                        <Button
                            type='primary'
                            href='/user_profile/user_tags/new'
                        >新增标签</Button>
                    </Space>
                </Col>}
            </Row>
            <Row style={{ margin: '12px 0 0 0' }}>
                <Col flex='100%'>
                    <Table
                        rowKey='id'
                        size='small'
                        dataSource={this.state.tags}
                        pagination={{
                            total: this.state.total,
                            current: this.state.pageNo,
                            pageSize: this.state.pageSize,
                            onChange: (pageNo, pageSize) => this.refreshSummaries({ pageNo, pageSize })
                        }}
                        scroll={{ x: 1500, y: this.state.tableHeight }}
                    >
                        <Table.Column
                            title='标签名称'
                            dataIndex='name'
                            width={100}
                            fixed='left'
                            render={(name, { id }) => <Button
                                type='link'
                                href={`/user_profile/user_tags/detail/${id}`}
                            >{name}</Button>}
                        />
                        <Table.Column
                            title='字段名'
                            width={100}
                            ellipsis
                            dataIndex='fieldName'
                        />
                        <Table.Column
                            title='所属表名'
                            dataIndex='tableName'
                            width={80}
                            render={tableName => <Button type='link' onClick={() => window.open(`/data_map/schema_desc/detail/bcz_datap/${tableName}`)}>{tableName}</Button>}
                        />
                        <Table.Column
                            title='枚举值'
                            dataIndex='enumValues'
                            ellipsis
                            width={100}
                        />
                        <Table.Column
                            title='覆盖率'
                            dataIndex='coverageRate'
                            width={50}
                        />
                        <Table.Column
                            title='创建时间'
                            dataIndex='createdAt'
                            width={80}
                        />
                        {AuthFetchService.allow('datap:admin') && <Table.Column
                            title='操作'
                            fixed='right'
                            width={80}
                            render={(_, { id }) => <>
                                <Button
                                    type='link'
                                    href={`/user_profile/user_tags/edit/${id}`}
                                >编辑</Button>
                                <Popconfirm
                                    title="是否删除指定的标签？"

                                    onConfirm={async () => {
                                        await UIFetchService.delete(`/api/v1/user_tags/tags/${id}`);
                                        await this.refreshSummaries({ pageNo: 1 });
                                        message.success('删除成功！');
                                    }}
                                >
                                    <Button danger type='link'>删除</Button>
                                </Popconfirm>
                            </>}
                        />}
                    </Table>
                </Col>
            </Row>
            {this.state.metadataModal.visible && <UserTagsMetadataModal
                {...this.state.metadataModal}
                onClose={() => this.setState(({ metadataModal }) => {
                    metadataModal.visible = false;
                    return { metadataModal };
                })}
            />}
        </>;
    }

    async componentDidMount() {
        await this.refreshSummaries();
        //UserTagsManagementView.tableDelta
        window.onresize = () => {
            this.setState({ tableHeight: document.body.clientHeight - UserTagsManagementView.tableDelta });
        }
        auth.appendLog('标签管理');
    }

    currentClass2Options() {
        if (this.state.categoryClass1Key === 'all') {
            return [];
        }
        const opt = userTagsCategoryInfos.find(info => info.key === this.state.categoryClass1Key);
        if (opt) {
            return opt.children;
        } else {
            return [];
        }
    }

    static filterKeys = [
        'objectKindKey',
        'timeKindKey',
        'processingKindKey',
        'categoryClass1Key',
        'categoryClass2Key',
        'searchKey',
        'pageNo',
        'pageSize'
    ];

    async refreshSummaries(params) {
        if (params === undefined) {
            params = {};
        }
        for (const key of UserTagsManagementView.filterKeys) {
            if (params[key] === undefined) {
                params[key] = this.state[key];
            }
        }
        this.setState(params);

        const query = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        const rs = await UIFetchService.get(`/api/v1/user_tags/tags?${query}`);
        if (!rs) {
            return;
        }

        this.setState({ total: rs.total, tags: rs.items });
    }
};

class SegmentSelect extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
        };
    }

    render() {
        return <Row>
            {this.props.options.map(opt => {
                const isSelected = opt.key === this.props.value;
                return <Col
                    key={opt.key}
                    style={{
                        textAlign: 'left',
                        cursor: 'pointer',
                        padding: '0px 10px',
                        margin: '0px 10px',
                        background: isSelected && '#f0f0f0'
                    }}
                    onClick={() => this.props.onChange(opt.key)}
                >
                    <span
                        style={{
                            color: isSelected && '#40a9ff',
                            fontSize: 12,
                            fontWeight: isSelected && 600
                        }}
                    >{opt.title}</span>
                </Col>
            })}
        </Row>
    }
};

export default UserTagsManagementView;
